<template>
  <div>
    <!--      栅格布局-->
    <el-row class="fh">
      <el-col :span="5">
        <el-card shadow="never" class="card-body-none fh" style="overflow-y: auto;height: 340px">
          <div slot="header" class="clearfix">
            <!--              点击所有存货，展示所有数据-->
            <el-button type="text" style="padding: 0 11px" @click="getAllMenus">所有供应商>></el-button>
          </div>
          <!--            树形结构的表格   columns：查看所选择的某一个连续范围内的一系列单元格的总列数-->
          <tree-table highlight-current-row :data="modulesTree" :columns="columns" @row-click="treeClick"
                      border></tree-table>
        </el-card>
      </el-col>
      <el-col :span="13">
        <div>
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"
                    :placeholder="'供应商名称'"
                    v-model="listQuery.keyword">
          </el-input>
          <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索
          </el-button>
          <el-table class="table" ref="mainTable" style="width: 100%;height: 260px" :key='tableKey' :data="list"
                    v-loading="listLoading" border fit
                    height="308"
                    highlight-current-row @selection-change="handleSelectionChange">

            <!--            <el-table-column type="selection" align="center" width="55"></el-table-column>-->
            <el-table-column align="center" width="100" :label="'选中'">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleSelectionChange(scope.row)">选中</el-button>
              </template>
            </el-table-column>
            <el-table-column min-width="100px" :label="'供应商名称'" prop="cPersonCode">
              <template slot-scope="scope">
                <span>{{ scope.row.venName }}</span>
              </template>
            </el-table-column>

            <el-table-column min-width="100px" :label="'联系人'" prop="cPersonName">
              <template slot-scope="scope">
                <span>{{ scope.row.contact }}</span>
              </template>
            </el-table-column>

            <el-table-column min-width="100px" :label="'联系电话'" prop="cDepCode">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column min-width="100px" :label="'付款信息'" prop="cDepName">
              <template slot-scope="scope">
                <span>{{ scope.row.payInfo }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total>0" :total="total" :pageSizes="pageSizes" :page.sync="listQuery.page"
                      :limit.sync="listQuery.limit" @pagination="getList"/>
        </div>
      </el-col>
      <el-col :span="6">
        <el-button type="text" disabled style="height: 32px">已选择供应商</el-button>
        <el-table class="table" ref="mainTable" style="width: 100%;height: 260px" :key='tableKey'
                  :data="multipleSelection"
                  v-loading="listLoading" border fit
                  height="308"
                  highlight-current-row>

          <!--          <el-table-column type="selection" align="center" width="55"></el-table-column>-->
          <el-table-column min-width="100px" :label="'操作'" align="center" fixed="left">
            <template slot-scope="scope">
              <el-button type="text" @click="removeEvent(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" :label="'供应商名称'" prop="cPersonCode">
            <template slot-scope="scope">
              <span>{{ scope.row.venName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="el-dialog__footer">
      <el-button size="mini" @click="close">取消</el-button>
      <el-button size="mini" type="primary" @click="submit">确认</el-button>
    </div>
  </div>
</template>

<script>
import { LoadSupply } from '@/api/tx_supplyinfos';
import waves from '@/directive/waves'; // 水波纹指令
import Pagination from '@/components/Pagination';
import * as tx_venclasss from '@/api/tx_venclasss';
// 导入树形表格
import treeTable from '@/components/TreeTable';
// 导入样式
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'selectsupplyinfo',
  props: ['accGuid', 'venids', 'venGuid', 'venName'],
  components: {
    Pagination, treeTable
  },
  directives: {
    waves
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      pageSizes: [100, 200, 300, 400, 500],
      listLoading: true,
      multipleSelection: [],
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        accGuid: this.accGuid,
        keyword: undefined,
        venClass: '',
        venids: this.venids
      },
      columns: [
        // treetable的列名
        {
          text: '供应商分类编号',
          value: 'classification'
        },
        {
          text: '供应商分类名称',
          value: 'classificationName'
        }
      ],
      modulesTree: [], // 树形模块
      options: [], // 树形结构的数据
      selectMenus: [], // 菜单列表选中的值
      modules: [], // 模块
      venNameArray: [],
      venGuidArray: []
    };
  },
  computed: {
    isRoot: {
      get() {
        return this.chkRoot;
      },
      set(v) {
        this.chkRoot = v;
        if (v) {
          this.temp.parentClassificationName = '根节点';
          this.temp.parentId = null;
        }
        // this.treeDisabled = v
      }
    },
    // 树形数据的属性
    modulesTreeRoot() {
      const root = [{
        name: '根节点',
        parentId: '',
        id: '',
        classification: ''
      }];
      // 把两个数组合并
      return root.concat(this.modulesTree);
    },
    // 分页属性
    currentPageMenus: {
      get() {
        var start = (this.listQuery.page - 1) * this.listQuery.limit;
        var end = (this.listQuery.page * this.listQuery.limit);
        var result = this.list.slice(start, end);
        return result;
      }
    },
    dpSelectModule: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogStatus === 'update') {
          return this.temp.parentId || '';
        } else {
          return '';
        }
      },
      set: function(v) {
        if (v === undefined || v === null || !v) {
          // 如果是根节点
          this.temp.parentClassificationName = '根节点';
          this.temp.parentId = null;
          // this.isRoot = true
          return;
        }
        // this.isRoot = false
        this.temp.parentId = v;
        var parentClassificationName = this.modules.find(val => {
          return v === val.id;
        }).name;
        this.temp.parentClassificationName = parentClassificationName;
      }
    }
  },
  created() {
    this.getList();
    if (this.venName) {
      this.venNameArray = this.venName.split(',');
      this.venGuidArray = this.venGuid.split(',');
    }
    if (this.venGuidArray[0]) {
      this.venGuidArray.forEach((item, index) => {
        const obj = {};
        obj.id = item;
        obj.venName = this.venNameArray[index];
        this.multipleSelection.push(obj);
      });
    }
  },
  watch: {
    accGuid(val) {
      console.log(val);
      this.listQuery.accGuid = val;
    }
  },
  mounted() {
    // 初始化页面完成后，刷新树形结构
    this.getModulesTree();
  },

  methods: {
    removeEvent(val) {
      this.multipleSelection = this.multipleSelection.filter((item) => {
        return item.id !== val.id;
      });
    },
    getList() {
      this.listLoading = true;
      LoadSupply(this.listQuery).then(response => {
        this.list = response.data;
        this.total = response.count;
        this.listLoading = false;
      });
    },
    AssTableData(val, tabledata) { // 添加或修改查询数据
      tabledata = tabledata.filter(u => u.value !== '');
      val.forEach(item => {
        const index = tabledata.findIndex(m => {
          return m.field === item.field;
        });
        if (index > -1) {
          if (item.value === null) {
            tabledata.splice(index, 1);
          } else {
            tabledata[index].value = item.value;
            tabledata[index].relation = item.relation ? item.relation : '==';
          }
        } else {
          tabledata.push({
            field: item.field,
            value: item.value,
            relation: item.relation ? item.relation : '=='
          });
        }
      });
      return tabledata;
    },
    // 递归,只需少量程序就可描述出解题过程，大大减少了程序的代码量。函数将自身作为子例程调用。 简单说程序调用自身的编程技巧叫递归
    recursion(array, data) {
      // 定义临时的数组
      const interim = this.modules.filter(u => u.parentClassification === data.classification);
      for (let i = 0; i < interim.length; i++) {
        // 把子集放进去
        array.push(interim[i].classification);
        this.recursion(array, interim[i]);
      }
    },
    // 左侧treetable点击事件
    treeClick(data) {
      // 先定义一个数组,放父级和父级本身以及下面子集的数据
      const array = [];
      // 先把自己放进去
      array.push(data.classification);
      this.recursion(array, data);
      this.currentModule = data;
      this.listQuery.venClass = array.join("','");
      this.getList();
    },
    // 树结构传出数据方法
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      tx_venclasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            classification: item.classification,
            classificationName: item.classificationName,
            parentClassification: item.parentClassification
          };
        });
        // 将一个带层级的数据列表转成树结构
        var modulestmp = _this.modules.map(o => ({ ...o }));
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'classification',
          parentKey: 'parentClassification',
          strict: true
        });
      });
    },
    // 点击所有存货，展示所有数据的方法  listQuery查询
    getAllMenus() {
      this.currentModule = null;
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'venClass',
          value: null,
          relation: '=='
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    handleSelectionChange(val) {
      const index = this.multipleSelection.findIndex(u => u.id === val.id);
      if (index === -1) {
        this.multipleSelection.push(val);
      }
    },
    handleFilter() {
      this.radioVal = '';
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    close() {
      this.$emit('close');
    },
    submit() {
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        const radiolist = this.multipleSelection.map(o => ({ ...o }));
        this.$emit('closeMoule', radiolist);
      } else {
        this.$alert('请选择供应商!', '', {
          confirmBuwarningttonText: '确定',
          type: 'warning',
          center: 'true'
        });
        return;
      }
    }
  }
};
</script>
